import { client } from "../../../Infrastructure/agent";

export const preferenceService = {
  setIsNavigationBarCollapsed: (
    collapsed,
    userId = "d4037eb2-f056-4ced-94d2-824ffb7606e3"
  ) => client.post(`/main/setUserPreference`, { collapsed, userId }),
};

